import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore from './redux/store';

const store = configureStore();
store.subscribe(()=>{
	localStorage.setItem(process.env.REACT_APP_LOCAL_STORAGE_NAME, JSON.stringify(store.getState()));
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<Provider store={store}>
    	<App />
	</Provider>
);

reportWebVitals();
